(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_jp-add-to-bag"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jp-add-to-bag]');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-jp-add-to-bag');
    if (!variantId) return;

    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
